import styled from 'styled-components';
import {
  FilterType,
  ProgressStatusList,
  PTypeProgressStatusList,
} from '../FilterData';
import { useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
} from './OptionModal.styles';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function ProgressStatusOption({ onClose, filters, setFilters }: Props) {
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);
  const [selectedItem, setSelectedItem] = useState<string>(
    filters.progressStatus,
  );

  const toggleGroup = (label: string) => {
    setExpandedGroups((prev) =>
      prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label],
    );
  };

  const toggleItem = (value: string) => {
    setSelectedItem(value);
  };

  const handleReset = () => {
    setSelectedItem('');
  };

  const handleSubmit = () => {
    onClose();
    setFilters({
      ...filters,
      progressStatus: selectedItem,
    });
  };

  return (
    <Wrapper>
      <OptionWrapper>
        {filters.type === 'a' && (
          <Option onClick={() => toggleItem('전체')}>
            {selectedItem === '전체' ? (
              <img src="/assets/images/check/circle-checked-blue.svg" alt="" />
            ) : (
              <img src="/assets/images/check/circle-checked-gray.svg" alt="" />
            )}
            전체
          </Option>
        )}
        {filters.type === 'a'
          ? ProgressStatusList.filter(({ label }) => label !== '전체').map(
              ({ label, options }) => {
                return (
                  <Group key={label}>
                    <GroupTitle onClick={() => toggleGroup(label)}>
                      {label}
                      {expandedGroups.includes(label) ? (
                        <img
                          src="/assets/images/arrow/black_arrow_up_20.svg"
                          alt=""
                        />
                      ) : (
                        <img
                          src="/assets/images/arrow/black_arrow_down_20.svg"
                          alt=""
                        />
                      )}
                    </GroupTitle>

                    {expandedGroups.includes(label) &&
                      options.map(
                        (option: { value: string; label: string }) => (
                          <Option
                            key={option.value}
                            onClick={() => toggleItem(option.label)}
                          >
                            <img
                              src={`/assets/images/check/${selectedItem.includes(option.label) ? 'circle-checked-blue' : 'circle-checked-gray'}.svg`}
                              alt=""
                            />
                            {option.label}
                          </Option>
                        ),
                      )}
                  </Group>
                );
              },
            )
          : PTypeProgressStatusList.map(
              (option: { value: string; label: string }) => (
                <Option
                  key={option.value}
                  onClick={() => toggleItem(option.label)}
                >
                  <img
                    src={`/assets/images/check/${selectedItem.includes(option.label) ? 'circle-checked-blue' : 'circle-checked-gray'}.svg`}
                    alt=""
                  />
                  {option.label}
                </Option>
              ),
            )}
      </OptionWrapper>
      <Bottom>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default ProgressStatusOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OptionWrapper = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
`;

const Option = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: center;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const GroupTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 0;

  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;
